import { create } from 'zustand';

interface FinanceUIState {
  lastPeriodId: string | null;
  setLastPeriodId: (id: string) => void;
}

export const useFinanceUIStore = create<FinanceUIState>(set => ({
  lastPeriodId: null,
  setLastPeriodId: id => set({ lastPeriodId: id }),
}));
